import pollTransaction from './pollTransaction'
import { BookingService } from '@/modules/banking/services'
import lang from '@/lang'
import { generateProcessId } from '@/modules/banking/_helpers/generateProcessId'

export const startContactChangePollRequest = (bankContactId, changedata, processId = null) => {
  changedata.silent = true
  if (!processId) {
    processId = generateProcessId()
  }
  return BookingService.changeContactTanProcedure(bankContactId, processId)
    .then(({ body: { data } }) => {
      if (!data) {
        return Promise.reject(new Error(lang.noBankingPsd2Transaction))
      }
      return pollTransaction({ ...data, meta: changedata }, 'bookingApi', processId)
    })
    .then((result) => {
      return Promise.resolve(result)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export default startContactChangePollRequest
